//=====================================================
//　ローディング表示
//=====================================================

interface IFProps {
    children: any,
    overlay: boolean,
    loadingDone: boolean,
    minHeight?: number,
}

export function LoadingBox(props: IFProps){

    let statusClass = "";
    let minHeight = 300;
    if (props.overlay){
        statusClass += " loading-overlay"
    }
    if (props.loadingDone){
        statusClass += " loading-done";
    }
    if (props.minHeight!==undefined){
        minHeight = props.minHeight;
    }
    return (
        <div className={"loading" + statusClass} style={{minHeight:minHeight}} >
            <div className="loading-before">
                <div className="loading-dot1"></div><div className="loading-dot2"></div><div className="loading-dot3"></div>
            </div>
            <div className="loading-after">
                {props.children}
            </div>
        </div>
    )

}